
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#icon-nav-reports_svg__clip0)"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M2.683 14h8.4a2.1 2.1 0 002.1-2.1V4.466a2.1 2.1 0 00-.528-1.393L11.5 1.77 10.603.729A2.1 2.1 0 009.013 0h-6.33a2.1 2.1 0 00-2.1 2.1v9.8c0 1.16.94 2.1 2.1 2.1zm7-12.194l.764.886.716.808h-1.48V1.806zm-1.4-.406v2.8a.7.7 0 00.7.7h2.8v7a.7.7 0 01-.7.7h-8.4a.7.7 0 01-.7-.7V2.1a.7.7 0 01.7-.7h5.6zM4.083 7a.7.7 0 01.7-.7h4.2a.7.7 0 110 1.4h-4.2a.7.7 0 01-.7-.7zm.7 2.1a.7.7 0 100 1.4h4.2a.7.7 0 100-1.4h-4.2z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"icon-nav-reports_svg__clip0"}},[_c('path',{attrs:{"d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    